// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"5b8eddbce890da40f7f8","774":"35c45a233e1c75f09838","826":"f2d68e9cd74ff2bcd49b","932":"6f3fc938f8bb81a523e5"}[chunkId] + ".js";
};